import React from "react"
import { Col, Row } from "react-bootstrap"

import { ReservedFields } from "@/onboarding/features/product/models/Product"
import Field from "@/onboarding/features/product/components/shared/Field"
import CruiseLineOnly from "@/auth_descriptor/CruiseLineOnly"

const Content = (): JSX.Element => (
  <div className="d-flex flex-column gap-3">
    <Field name={ReservedFields.WEBSITE_TOUR_NAME} label="Website Tour Name" />
    <Field name={ReservedFields.OVERVIEW} label="Overview (Romance Copy)" />
    <CruiseLineOnly>
      <Field
        name={ReservedFields.WEBSITE_CANCELLATION_POLICY}
        label="Website Cancellation Policy"
      />
    </CruiseLineOnly>
    <Row>
      <Col>
        <Field name={ReservedFields.HIGHLIGHTS} label="Highlights" />
      </Col>
      <Col>
        <Field name={ReservedFields.IMPORTANT_NOTES} label="Important Notes" />
      </Col>
    </Row>
    <Row>
      <Col>
        <Field name={ReservedFields.WHAT_TO_BRING} label="What to Bring" />
      </Col>
      <Col>
        <Field name={ReservedFields.WHAT_TO_WEAR} label="What to Wear" />
      </Col>
    </Row>
  </div>
)

export default Content
